export default __webpack_public_path__ + "static/media/Error.2fcef9da.svg";